import React, { useEffect, useRef, useState } from 'react';
import ComCurtainSingleThread from './ComCurtainSingleThread';
import { DEFAULT_API_URL } from '../../../constents';
import setUiMessage from '../../../Utilities/Tostify';
import uploadfiles from '../../../Utilities/handleUploadFiles';
import PatientSerchPopUpForApp from '../../PatientSerchPopUpForApp';
import { post } from '../../Auths/AuthToken';
import Button from '../../Button';
import { CiShare1 } from 'react-icons/ci';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../../redux/slices/appSlice';

function ComCurtainSingleMsgView({
  closeMainComCurtain,
  close,
  data,
  handleReload = () => {},
  setSelRecipentPopUp,
  setMsgId,
  setMsgType,
  handleDeleteSingleMsg,
  handleFlagChange,
  flag,
}) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const fileInputRef = useRef(null);
  const divRef = useRef(null);
  const [textMsg, setTextMsg] = useState('');
  const [searchPatPopup, setSearchPatPopup] = useState(false);
  const [attachedPatients, setAttachedPatients] = useState([]);
  const [finalFiles, setFinalFiles] = useState([]);
  const [flagCurState, setflagCurState] = useState(flag);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight;
    }
  }, []);

  const handleAttachDocs = () => {
    fileInputRef.current.click();
  };

  const handleRemovePat = (patIndex) => {
    const updateSelectedPats = [...attachedPatients];
    updateSelectedPats.splice(patIndex, 1);
    setAttachedPatients(updateSelectedPats);
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const apiUrl = `${DEFAULT_API_URL}/api/communication/Communication/uploadImageForReply`;
      const responce = await uploadfiles(apiUrl, file);
      if (responce.data?.successCode === 'success') {
        setFinalFiles((items) => {
          return [
            ...items,
            {
              fileName: responce.data?.fileName,
              filePath: responce.data?.flePathName,
            },
          ];
        });
      } else if (responce.data?.successCode === 'error') {
        setUiMessage('err', responce?.data?.msg);
      }
    } else {
      setUiMessage('err', 'Please select file');
    }
  };

  const handleRemoveAttachFile = (index) => {
    const newAttachArr = [...finalFiles];
    newAttachArr.splice(index, 1);
    setFinalFiles(newAttachArr);
  };

  const handleReplyMsg = async () => {
    let prams = {
      msgId: data?.parentId, // msg parent Id
      msgType: data?.type, // 1,2,3
      from: data?.fromuser,
      to: data?.touser,
      loginUserId: user?.id,
      msg: textMsg.trim(),
      isThread: '0', //0 or 1
      attachments: '',
      attachedPatientIds: '',
    };
    if (data?.type === '2') {
      if (data?.is_thread === '1') {
        prams = {
          ...prams,
          isThread: '1', //0 or 1
        };
      } else {
        prams = {
          ...prams,
          attachments: finalFiles.map((item) => item?.fileName).join(','),
        };
      }
    } else if (data?.type === '3') {
      prams = {
        ...prams,
        attachments: finalFiles.map((item) => item?.fileName).join(','),
        attachedPatientIds: attachedPatients
          .map((item) => item?.userId)
          .join(','),
      };
    }
    if (!!prams.msg) {
      try {
        const response = await post(
          'api/communication/Communication/replyMsg',
          {
            ...prams,
          }
        );
        if (response?.status === 200) {
          setTextMsg('');
          setMsgId(data?.parentId);
          setMsgType(data?.type);
          handleReload();
          dispatch(handleGlobalReload(!globalReload));
          if (response?.data?.status === 'smssent') {
            setUiMessage('suc', 'Message sent successfully.');
          }
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Message sent successfully.');
          }
          close();
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    } else {
      setUiMessage('err', 'Please write some message.');
    }
  };
  const handleFlagClick = () => {
    const flagState = flagCurState === '1' ? '0' : '1';
    setflagCurState(flagState);
    const isFromInside = true;
    handleFlagChange(data?.parentId, data?.type, flagState, isFromInside);
  };

  return (
    <div
      className="left com-curtn-mn-cntnr"
      style={{ right: 'unset', top: 'unset' }}
      id=""
    >
      <div className="flex-sec com-curtn-hdr justify-between item-center">
        <div className="com-curtn-clse">Communication:</div>
        <Button
          variant="outline"
          className=""
          onClick={() => {
            setSelRecipentPopUp();
            closeMainComCurtain();
          }}
        >
          <div className="flex-sec item-center gap10">
            New <CiShare1 />
          </div>
        </Button>
      </div>
      <div className="left com-curtn-bdy-rply" ref={divRef}>
        <div className="left com-curtn-bdy-rw curtn-sbj">
          <span className="left com-curtn-icn">
            {data?.type === '3' ? 'CL' : 'Pt.'}
          </span>
          {data?.subLine && (
            <span className="left com-curtn-sbjct">
              {/* {data?.subLine} */}
              {/* <span
              dangerouslySetInnerHTML={{
                __html: data?.subLine ? data?.subLine : '',
              }}
            /> */}
              {data?.subLine.replace(/\\'/g, "'")}
            </span>
          )}
        </div>
        {data?.threadList &&
          data?.threadList.map((item, i) => {
            const altClas = i % 2 !== 0 ? 'alt-rw' : '';
            return (
              <ComCurtainSingleThread
                key={i}
                altClas={altClas}
                data={item}
                type={data?.type}
              />
            );
          })}
      </div>
      <div className="left com-curtn-btn">
        <textarea
          className="curtn-replyarea"
          placeholder="Write your reply here..."
          value={textMsg}
          onChange={(e) => setTextMsg(e.target.value)}
          disabled={data?.replyAccess === '0' ? true : false}
          autoFocus
        ></textarea>
        <div
          className={`left width100 com-atchmnt-rw ${
            data?.type === '3' ? '' : 'hide'
          }`}
        >
          <div className="left width100">
            <span className="left width100">
              <span>
                <span
                  className="link-color" //quick-links
                  style={{ cursor: 'pointer' }}
                  onClick={() => setSearchPatPopup(true)}
                >
                  Attach Patient
                </span>
              </span>
              <span className="red"> | </span>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileSelect}
              />
              <span
                className="link-color" //quick-links
                style={{ cursor: 'pointer' }}
                onClick={handleAttachDocs}
              >
                Attach Documents
              </span>
            </span>
          </div>
          <div className="left width100 fontsize12">
            {attachedPatients && attachedPatients.length > 0 && (
              <div className="left width100 crtn-atchd-ptnt">
                {attachedPatients?.map((item, i) => {
                  return (
                    <li key={i}>
                      <span className="nm">
                        {item?.patName} <span className="red"> | </span> ID:
                        {item?.chart_number} <span className="red"> | </span>{' '}
                        DOB: {item?.dob}
                      </span>
                      <span
                        className="rm cursor red bold"
                        onClick={() => handleRemovePat(i)}
                      >
                        X
                      </span>
                    </li>
                  );
                })}
              </div>
            )}
            {finalFiles && finalFiles.length > 0 && (
              <div className="left width100 crtn-atchd-doc">
                {finalFiles &&
                  finalFiles.length > 0 &&
                  finalFiles?.map((item, i) => {
                    return (
                      <li key={i}>
                        <span className="nm">
                          <a
                            href={item?.filePath}
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            {item?.fileName}
                          </a>
                        </span>
                        <span
                          className="rm red bold"
                          onClick={() => handleRemoveAttachFile(i)}
                        >
                          X
                        </span>
                      </li>
                    );
                  })}
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <span
          className="sndrcv-lt-dlt"
          style={{ width: '5%' }}
          onClick={() => {
            handleDeleteSingleMsg(data?.parentId, data?.type);
          }}
        >
          &#128465;
        </span>
        <span
          className={
            flagCurState === '1'
              ? 'sndrcv-lt-dlt actv-cm-flagged'
              : 'sndrcv-lt-dlt'
          }
          style={{ width: '5%' }}
          onClick={handleFlagClick}
        >
          &#9872;
        </span>
      </div>
      <div
        className="com-curtn-btn flex-sec"
        style={{ justifyContent: 'space-between' }}
      >
        <Button
          className=""
          variant="outline"
          onClick={() => {
            close();
            handleReload();
          }}
        >
          &#171; Back
        </Button>
        <div className="flex-sec">
          <Button
            className="clear-right"
            variant="default"
            onClick={closeMainComCurtain}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleReplyMsg}
            className={`${data?.replyAccess === '0' ? 'hide' : ''}`}
          >
            Send
          </Button>
        </div>
        {/*<div
          className={`button-submit right ${
            data?.replyAccess === '0' ? 'hide' : ''
          }`}
          style={{
            width: '180px !important',
            marginRight: 'calc(50% - 115px)',
          }}
          onClick={handleReplyMsg}
        >
          Send
        </div>*/}
      </div>
      {searchPatPopup && (
        <PatientSerchPopUpForApp
          multiSelect={true}
          handlePatArr={(pats) => setAttachedPatients(pats)}
          handleClosePatSerch={() => {
            setSearchPatPopup(false);
          }}
          defaultPat={attachedPatients}
        />
      )}
    </div>
  );
}

export default ComCurtainSingleMsgView;
